import axios from 'axios';
import type { IRes, ICallError } from '@/typings/api';

const api = axios.create({
    baseURL: import.meta.env.DEV ? '/proxy/' : import.meta.env.VITE_APP_API_BASEURL as string,
    // baseURL: import.meta.env.VITE_APP_API_BASEURL as string,
    timeout: 5000,
    responseType: 'json'
});

api.interceptors.request.use(
    request =>
    {
        /**
         * 全局拦截请求发送前提交的参数
         * 以下代码为示例，在登录状态下，分别对 post 和 get 请求加上 token 参数
         */
        if (request.method === 'post')
        {
            if (request.data instanceof FormData)
            {
                // 如果是 FormData 类型（上传图片）
            }
            else
            {

                if (request.data === undefined)
                {
                    request.data = {};
                }
            }
        }
        else
        {
            if (request.params === undefined)
            {
                request.params = {};
            }
        }
        return request;
    }
);

api.interceptors.response.use(
    response =>
    {
        /**
         * 全局拦截请求发送后返回的数据，如果数据有报错则在这做全局的错误提示
         * 返回的数据格式为：
         * {
         *  data: array| object,
         *  code: number, //0=成功，1=失败，-1=未授权（待定）
         *  message: 'success', // 当 code 为0时，值为'success'，非0时会具体失败的错误信息
         *  localTime:string
         * }
         * 规则是当 code 为 0 时表示请求成功，为 非0 时表示接口需要登录或者登录状态失效，需要重新登录
         * 请求出错时 error 会返回错误信息
         * 后端返回的数据存在 response.data 属性中
         */
        // console.log('response', response);
        if (response.data.code === 0) // 成功
        {
            // 请求成功并且没有报错
            return Promise.resolve(response.data as IRes<unknown>);
        }
        else if (response.data.code === -1) // 未授权
        {
            // toLogin();
        }
        else // 失败
        {
            // 返回错误，由调用方处理reject状态处理
            return Promise.reject({ code: response.data.code, message: response.data.message } as ICallError);
        }
    },
    error => // http通用错误
    {
        let message = error.message;
        const { data, status, statusText } = error.response;
        if (message === 'Network Error')
        {
            message = '后端网络故障';
        }
        else if (message.includes('timeout'))
        {
            message = '接口请求超时';
        }
        else if (message.includes('Request failed with status code'))
        {
            message = '接口' + message.substr(message.length - 3) + '异常';
        }

        // console.log('[API Error]', Object.keys(error), status, statusText);

        // 返回错误，由调用方处理reject状态处理
        return Promise.reject({ code: status, message: message } as ICallError);
    }
);

export default api;
